import { Contact } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function CustomersPage() {
  return (
    <PhaseStubPage
      title="Customers"
      phase={4}
      modules={[
        'Customer directory with billing / shipping addresses',
        'Pricing tiers and customer-specific price lists',
        'Credit terms, hold flags, and AR aging snapshot',
        'Contacts, channels, and primary salesperson assignment',
      ]}
      icon={Contact}
    />
  );
}
